const translation = {
  EXPERIENCE_TITLE_H5: 'What Skills I Have',
  EXPERIENCE_TITLE_H2: 'My Experience',
  FRONT_END_TITLE: 'Frontend Development',
  BACK_END_TITLE: 'Backend Development',
  ADVANCED: 'Advanced',
  EXPERIENCED: 'Experienced',
  BASIC: 'Basic',
  MID_LEVEL: 'Mid Level',
};

export default translation;
